// Generated by purs version 0.14.4
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
var cmap = function (f) {
    return function (c) {
        return function (b) {
            return c(f(b));
        };
    };
};
var cmapFlipped = function (x) {
    return function (f) {
        return cmap(f)(x);
    };
};
var cvoid = cmap(function (v) {
    return Data_Unit.unit;
});
var cvoidLeft = function (c) {
    return function (x) {
        return cmap(Data_Function["const"](x))(c);
    };
};
var cvoidRight = function (x) {
    return function (c) {
        return cmap(Data_Function["const"](x))(c);
    };
};
export {
    cmap,
    cmapFlipped,
    cvoid,
    cvoidRight,
    cvoidLeft
};
//# sourceMappingURL=index.js.map
